const STUDIES_TABS = {
  ONGOING: 'Ongoing',
  UNASSIGNED: 'Unassigned',
  COMPLETED: 'Completed',
  DELETED: 'Deleted',
  ARTIFACT: 'Artifact',
};

export { STUDIES_TABS };
